import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { CssButton } from '../../../../components/Forms/styles';
import { PageContext } from '../../context';
import {
  ServiceWrapper, ServiceInfo, ServiceTitle, ServiceDescription, CallOut,
} from './styles';

const ServiceType = ({ service }) => {
  const context = useContext(PageContext);

  const { selectServiceById } = context;

  const {
    id: serviceId, name, priceCents, durationMinutes, btnLabel, pricingType,
  } = service;

  const handleBookClick = useCallback(
    (bookId) => {
      selectServiceById(bookId);
    },
    [selectServiceById],
  );

  return (
    <ServiceWrapper>
      <ServiceInfo>
        <ServiceTitle>{name}</ServiceTitle>
        <ServiceDescription>
          {pricingType === 'N_A' && <CallOut> N/A </CallOut>}
          {pricingType === 'PRICE_ON_REQUEST' && <CallOut> Price on request </CallOut>}
          {pricingType === 'FIXED_PRICE' && <CallOut>{`$${+priceCents / 100} `}</CallOut>}
          for
          <CallOut>{` ${durationMinutes} `}</CallOut>
          minutes
        </ServiceDescription>
      </ServiceInfo>
      <CssButton className="brand" onClick={() => handleBookClick(serviceId)}>
        {btnLabel || 'Book'}
      </CssButton>
    </ServiceWrapper>
  );
};

ServiceType.defaultProps = {};

ServiceType.propTypes = {
  service: PropTypes.shape().isRequired,
};

export default ServiceType;
